/* generated by pull.js */
const manifest = {
  editorOnly: true,
  noTranslations: true,
  name: 'Keep block comment connections straight',
  description:
    'Forces block comments to always be connected to their source block by a horizontal straight line, not at an angle.',
  tags: [],
  credits: [
    {
      name: 'lisa_wolfgang',
      link: 'https://scratch.mit.edu/users/lisa_wolfgang/'
    }
  ],
  userscripts: [
    {
      url: 'userscript.js'
    }
  ],
  dynamicDisable: true,
  enabledByDefault: false
};
export default manifest;
